import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { routes } from '@client/routes';
import { HistoryManagerProvider } from '@client/lib/HistoryManager';

import './App.scss';

export const App: React.FC = () => (
    <HistoryManagerProvider>
        <Routes>
            {routes.map(route => (
                <Route
                    key={route.path}
                    path={route.path}
                    Component={route.Component}
                />
            ))}
        </Routes>
    </HistoryManagerProvider>
);
